import Forms from '@/mixins/Forms'

export default {
    install(Vue, options) {

        const optionsDefaults = {}

        // Merge options argument into options defaults
        options = {
            ...optionsDefaults,
            ...options
        }
        
        Vue.mixin(Forms);

    }
}
